<script lang="ts" setup>
import CreateCheckCallForm from "@/views/trips/components/forms/CreateCheckCallForm.vue";
import type { CheckCallDTO, CreateCheckCallRequest } from "@/api/trips/dto/check-call";
import type { RouteStopDto } from "@/api/trips/dto/trip.dto";
import type { TripMonitorRouteStop } from "@/api/trips/dto/trip-monitor";

const props = defineProps<{
  routeId: number;
  routeStops: RouteStopDto[] | TripMonitorRouteStop[];
  creationLoading: boolean;
  checkCallPreview: CheckCallDTO | null;
  title: string;
  truckId: number;
  truckNumber: string;
  tripId?: number;
}>();

const emits = defineEmits<{
  (e: "success", checkCall: CheckCallDTO): void;
  (e: "create", checkCall: CreateCheckCallRequest): void;
  (e: "close"): void;
}>();
</script>

<template>
  <create-check-call-form
    :check-call-preview="props.checkCallPreview"
    :creation-loading="props.creationLoading"
    :route-id="props.routeId"
    :route-stops="props.routeStops"
    :title="props.title"
    :trip-id="props.tripId"
    is-dispatch-confirmation
    @close="emits('close')"
    @create="emits('create', $event)"
    @success="emits('success', $event)"
  >
    <template #subtitle>
      <div class="d-flex align-center mb-4">
        <span class="text-grey-darken-1"> You are about to confirm dispatch for</span>

        <router-link
          v-if="props.truckId"
          :to="{ name: 'truck-view', params: { id: props.truckId } }"
          class="text-primary text-decoration-none ml-1"
          data-qa="modal-truck-number"
          target="_blank"
        >
          Truck #{{ props.truckNumber }}
        </router-link>
      </div>
    </template>
  </create-check-call-form>
</template>

<style lang="scss" scoped></style>
